import {fieldRenderer as customFieldRenderer} from '../../conf/fieldRenderer'
const fieldRenderer = Object.assign({}, customFieldRenderer)

export {fieldRenderer}


// WEBPACK FOOTER //
// ./src/fm/conf/fieldRenderer.js